import { connect } from 'react-redux';
import { reduxForm } from 'redux-form';
import SimpleProblemLoggingInFormComponent from './SimpleProblemLoggingInFormComponent';
import { sendResetPasswordEmail, resendVerificationEmail } from '../../redux/actions/userActions';
var SimpleProblemLoggingInForm = reduxForm({
  form: 'forgotPassword',
  onSubmit: function onSubmit(payload, dispatch) {
    var resetPassword = payload.resetPassword,
      Email = payload.Email;
    if (resetPassword) return dispatch(sendResetPasswordEmail(Email));
    return dispatch(resendVerificationEmail({
      Email: Email
    }));
  },
  enableReinitialize: true
})(SimpleProblemLoggingInFormComponent);
var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    sendResetPasswordEmail: sendResetPasswordEmail,
    resendVerificationEmail: resendVerificationEmail
  };
};
var SimpleProblemLoggingInFormContainer = connect(null, mapDispatchToProps())(SimpleProblemLoggingInForm);
export default SimpleProblemLoggingInFormContainer;